const HeroSection = () => {
  const features = [
    "Low Investment",
    "High Returns", 
    "Trusted Network",
    "Verified Leads"
  ]

  return (
    <>
      {/* Desktop Layout */}
      <section className="hidden lg:block relative">
        <div className="w-full relative">
          <img
            src="https://assets.cars24.com/production/c2b-website/250924150348/js/493ca3ce7fa45358a69ae81f8c23e5e8.jpeg"
            alt="home banner"
            width={1440}
            height={672}
            className="w-full h-auto object-cover"
          />
          
          {/* Content Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-[rgba(0,42,92,0.85)] via-[rgba(0,42,92,0.7)] to-transparent" />
          
          {/* Content */}
          <div className="absolute inset-0 flex items-center">
            <div className="container mx-auto px-8">
              <div className="max-w-lg">
                <h1 className="text-5xl font-bold leading-tight text-white mb-6">
                  Own a Carz Bazzar
                  <br />
                  Franchise
                </h1>
                <p className="text-xl font-normal text-gray-200 mb-10">
                  Transform the used car business in your city
                </p>

                {/* Benefits */}
                <div className="grid grid-cols-2 gap-4 mb-10">
                  {features.map((feature, index) => (
                    <div key={index} className="flex items-center">
                      <img
                        src="https://assets.cars24.com/production/c2b-website/250924150348/js/eb1cf4f78726694d942a05a01f918cff.svg"
                        alt="Checkmark icon"
                        width={20}
                        height={20}
                        className="mr-3 flex-shrink-0"
                      />
                      <span className="text-base font-medium text-white">{feature}</span>
                    </div>
                  ))}
                </div>
                
                {/* CTA Button */}
                <a
                  href="tel:+919773460662"
                  className="inline-block rounded-lg px-8 py-4 text-base font-semibold uppercase tracking-wide text-white shadow-lg transition-transform hover:scale-105 hover:shadow-xl"
                  style={{
                    backgroundColor: '#ff3131',
                    boxShadow: '0 4px 12px rgba(255, 49, 49, 0.25)'
                  }}
                >
                  Register Interest
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Layout */}
      <section className="lg:hidden">
        {/* Hero Image */}
        <div className="w-full">
          <img
            src="https://assets.cars24.com/production/c2b-website/250924150348/js/ca3fffe355c12adcf63d8ecabce9274a.jpeg"
            alt="home banner"
            width={360}
            height={249}
            className="w-full h-auto object-cover"
          />
        </div>
        
        {/* Dark Blue Benefits Section */}
        <div className="bg-[#002A5C] py-8 px-6">
          {/* Main Heading */}
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-white mb-2">
              Own a Carz Bazzar
              <br />
              Franchise
            </h1>
            <p className="text-lg text-gray-200">
              Transform the used car business in your city
            </p>
          </div>
          
          {/* Benefits List */}
          <ul className="grid grid-cols-2 gap-4 mb-6 justify-items-center">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center">
                <img
                  src="https://assets.cars24.com/production/c2b-website/250924150348/js/eb1cf4f78726694d942a05a01f918cff.svg"
                  alt="tick"
                  width={20}
                  height={20}
                  className="mr-3 flex-shrink-0"
                />
                <span className="text-sm font-medium text-white">{feature}</span>
              </li>
            ))}
          </ul>
          
          {/* CTA Button */}
          <div className="text-center">
            <a
              href="tel:+919773460662"
              className="inline-block rounded-lg px-8 py-4 text-base font-semibold uppercase tracking-wide text-white shadow-lg transition-transform hover:scale-105 hover:shadow-xl"
              style={{
                backgroundColor: '#ff3131',
                boxShadow: '0 4px 12px rgba(255, 49, 49, 0.25)'
              }}
            >
              Register Interest
            </a>
          </div>
        </div>
      </section>
    </>
  )
}

export default HeroSection
